module.exports = __webpack_public_path__ + "static/barcelona_code_school_campus_-c19bc11b2224d856183d0efc4250f4dc.jpg";